import { buildUrl, usKidsGolfService } from '@/libs/api/instances/us-kids-golf-instance';
import type { RequestOptions } from '@/libs/api/types';

export const invitationPreviewEndpoint = (token: string) => `/invitations/${token}`;

export type InvitationPreview = {
  status: string;
  invitedEmail?: string;
  playerName: string;
  invitedByName: string;
  relationship: string;
  message: string;
  expiresAt: string;
  inviteUrl?: string;
};

/**
 * Preview an invitation by token (public) via
 * GET `/api/v1/invitations/{token}`
 */
export async function fetchInvitationPreview(
  token: string,
  options?: RequestOptions,
): Promise<InvitationPreview> {
  return await usKidsGolfService.get<InvitationPreview>(
    buildUrl(invitationPreviewEndpoint(token)),
    undefined,
    options,
  );
}
